import { render, staticRenderFns } from "./MenuCardVertical.vue?vue&type=template&id=00ece853"
import script from "./MenuCardVertical.vue?vue&type=script&lang=ts"
export * from "./MenuCardVertical.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports